import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import People from '../views/People.vue'
import Places from '../views/Places'
import Extra from '../views/Extra'
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    hash: "test",
    component: Home,
    meta: {
      inNavigation: true,
      navigationLabel: 'Episoder'
    }
  },
  {
    path: '/people',
    name: 'People',
    component: People,
    meta: {
      inNavigation: true,
      navigationLabel: 'Folk'
    }
  },
  {
    path: '/places',
    name: 'Places',
    component: Places,
    meta: {
      inNavigation: true,
      navigationLabel: 'Steder'
    }
  },
  {
    path: '/extra',
    name: 'Extra',
    component: Extra,
    meta: {
      inNavigation: true,
      navigationLabel: 'Ekstra'
    }
  }
  
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from) {
    if (from.name !== 'Home' && to.name === 'Home') {
      const el = document.querySelector('#content-start');
      return { x: 0, y: (el.offsetTop - 8) }
    } 
    return { x: 0, y: 0 }
  }  
})

export default router
